

module.exports = __webpack_require__.stylable.create(
    "MultiOfferings3747638281",
    {"classes":{"root":"MultiOfferings3747638281__root","cardContainer":"MultiOfferings3747638281__cardContainer","cardsContainer":"MultiOfferings3747638281__cardsContainer","MultiOfferingsTitle":"","Categories":"","OfferingList":""},"vars":{},"stVars":{},"keyframes":{}},
    "",
    12,
    "MultiOfferings3747638281",
    null
);
